import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

export interface IInterventionGetAllRequestAction {
  data: {
    category?: string[];
    custom?: string[];
    id: number;
    interventionType?: string[];
    intervention_ids: number[];
    page: number;
    status?: string[];
  };
  functions: {
    error: (err: any) => void;
  };
}

function getAllRequest(
  draft: Draft<IInterventionData>,
  action: PayloadAction<IInterventionGetAllRequestAction>,
) {
  draft.getAll.config.errorMsg = '';
  draft.getAll.config.emptyMsg = '';
  draft.getAll.config.isLoading = true;
  draft.getAll.config.pagination.page = action.payload.data.page;
}

export default getAllRequest;
